import { ApiError, NetworkError, detailLines } from '../api/errors';
import { Banner } from './layout';

// A refused action outside a form: the server's sentence, then status · code · requestId
// so a report can be matched to the log line.
export const MutationError = ({ error }: { error: unknown }) => {
  if (!error) return null;
  if (error instanceof NetworkError) {
    return <Banner>The request never left. Nothing was changed — try again.</Banner>;
  }
  if (!(error instanceof ApiError)) return <Banner>{String(error)}</Banner>;
  if (error.signedOut) return <Banner>{error.message}</Banner>;

  const fields = [
    ...error.fieldErrors.map((field) => `${field.field} — ${field.message}`),
    ...detailLines(error.rawDetails),
  ];
  const detail = [error.status, error.code, error.requestId].filter(Boolean).join(' · ');

  return (
    <Banner detail={detail}>
      {error.message}
      {fields.length > 0 && (
        <span className="mt-2 block font-mono text-meta text-muted">{fields.join(' · ')}</span>
      )}
    </Banner>
  );
};
